import { createSlice } from '@reduxjs/toolkit';

const initialState={
    apikey:null
}
export const apikeySlice = createSlice({
  name: 'apikey',
  initialState,
  reducers: {
    setApikey: (state, action) => {
        state.apikey = action.payload;
        
      },
      
    
    setLogoutApikey: (state,action)=>{
      state.apikey=null
    }
  },
});

export const {  setApikey,setLogoutApikey } = apikeySlice.actions;

export default apikeySlice.reducer;
